<template>
  <div class="pages_content table mobilebanner">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop">
          <div v-for="(item, index) in contractTypelist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
          </div>
        </div>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ 'arrowTransform': !showCardNav, 'arrowTransformReturn': showCardNav}">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span v-if="this.currenindex < 3" style="display: inline-block;margin-bottom: 10px;">
                <span style="margin-right: 12px;">公司</span>
                <el-select v-model="tableParam.companyId" :disabled="UserInfo.adminStatus !== 1" style="width: 240px;" placeholder="请选择">
                  <el-option v-for="(item, index) in companylist" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </span>
              <span>
                <span style="margin:0 12px;">状态</span>
                <el-select v-model="tableParam.enable" style="width: 240px;" placeholder="请选择">
                  <el-option label="启用" :value='1'></el-option>
                  <el-option label="禁用" :value='0'></el-option>
                </el-select>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left:12px;" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='TIANJIA'))!==-1" size="small" class="bottom_all" style="margin-left: 0;" @click="addData()">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
                添加
              </el-button>
              <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='RIYONG'))!==-1" size="small" class="bottom_three" @click="UpdateData(1)">
                <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px;"></i>
                启用
              </el-button>
              <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='JINYONG'))!==-1" size="small" class="bottom_four" @click="UpdateData(0)">
                <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px;"></i>
                禁用
              </el-button>
              <span v-if="this.currenindex < 3" style="margin:0 20px;">banner底色</span>
              <el-color-picker v-if="this.currenindex < 3" v-model="bgColor" style="top: 13px;" @change="changeColor"></el-color-picker>
            </div>
          </div>
          <div v-if="this.currenindex < 3" v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column label="序号" type="index" width="50" align="center">
              </el-table-column>
              <el-table-column prop="company" label="公司" width="180" align="center">
              </el-table-column>
              <el-table-column label="图片" width="180" align="center">
                <template slot-scope="scope">
                  <el-image :src="imageUri + scope.row.picturePath"></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="pictureUrl" label="URL" align="center">
              </el-table-column>
              <el-table-column prop="remark" label="备注" align="center">
              </el-table-column>
              <el-table-column prop="enable" label="状态" align="center">
                <template slot-scope="scope">
                  <el-tag>{{scope.row.enable===1?'启用':'禁用'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column v-if="ButtonList.findIndex(res=>(res.buttonValue=='XIUGAI'))!==-1" label="操作" align="left">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_one" @click="handleEdit(scope.row)">
                    修改</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="this.currenindex == 3" v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="startTableData" row-key="id" tooltip-effect="dark" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
              <el-table-column prop="businessSystemName" label="业务系统" width="180" align="center"></el-table-column>
              <el-table-column prop="applicationName" label="应用" width="180" align="center"></el-table-column>
              <el-table-column label="启动页" width="180" align="center">
                <template slot-scope="scope">
                  <el-image :src="imageUri + scope.row.startPage"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="广告页" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" class="bottom_info" @click="handleLook(scope.row.advertisingPage)">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="effectiveTime" label="生效时间" align="center"></el-table-column>
              <el-table-column prop="remark" label="备注" align="center"></el-table-column>
              <el-table-column prop="enable" label="状态" align="center">
                <template slot-scope="scope">
                  <el-tag>{{scope.row.enable===1?'启用':'禁用'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column v-if="ButtonList.findIndex(res=>(res.buttonValue=='XIUGAI'))!==-1" label="操作" align="left">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_one" @click="handleEdit(scope.row)">
                    修改</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" layout="prev, pager, next, jumper" :total="total" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <el-dialog v-if="this.currenindex < 3" v-dialogDrag :visible.sync="addDialog" width="580px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="dialogForm" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item v-if="currenindex===1" prop="companyId">
            <span slot="label" style="color:  #FF0000 ;">公司</span>
            <el-select v-model="fromDate.companyId" :disabled="UserInfo.adminStatus !== 1" placeholder="请选择">
              <el-option v-for="item in companylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="picturePath" label-width="110px">
            <span slot="label" style="color:  #FF0000 ;">图片</span>
            <el-upload class="avatar-uploader" action="/resource/resources/upload" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="upheader">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip" style="color:red">*{{upload_tip}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item prop="pictureUrl">
            <span slot="label">URL</span>
            <el-input v-model="fromDate.pictureUrl" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item prop="enable">
            <span slot="label">状态</span>
            <el-radio-group v-model="fromDate.enable">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="fromDate.remark" type="textarea" resize="none" style="width:320px" rows="5" placeholder="请输入内容">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="pagessubmitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- app启动页 -->
    <el-dialog v-else v-dialogDrag :visible.sync="addDialog" width="640px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="startDialogForm" :inline="true" :model="startFromDate" label-width="130px">
          <el-form-item v-if="currenindex===3" prop="businessSystemId">
            <span slot="label" style="color:  #FF0000 ;">业务系统</span>
            <el-select v-model="startFromDate.businessSystemId" :disabled="UserInfo.adminStatus !== 1" placeholder="请选择">
              <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="currenindex===3" prop="applicationName">
            <span slot="label" style="color:  #FF0000 ;">应用</span>
            <el-select v-model="startFromDate.applicationId" :disabled="UserInfo.adminStatus !== 1" placeholder="请选择">
              <el-option v-for="item in applicationlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="picturePath" label-width="130px">
            <span slot="label" style="color:  #FF0000 ;">启动页(单张)</span>
            <el-upload class="avatar-uploader" action="/resource/resources/upload" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="upheader">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip" style="color:red">*{{upload_tip}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="启动页停留时间" prop="startPageTime">
            <span slot="label" style="color:  #FF0000 ;">启动页停留时间</span>
            <el-input v-model.number="startFromDate.startPageTime" type="number" autocomplete="off"></el-input><span>&nbsp;秒</span>
          </el-form-item>
          <el-form-item prop="advertisingPage" label-width="130px">
            <span slot="label" style="color:  #FF0000 ;">广告页(多张)</span>
            <el-upload
              class="avatar-uploader"
              action="/resource/resources/upload"
              list-type="picture-card"
              :on-success="handleManySuccess"
              :before-upload="beforeAvatarUpload"
              :on-remove="handleRemove"
              :file-list="fileList"
              :headers="upheader">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip" style="color:red">*{{upload_tip}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item style="color:  #FF0000 ;" prop="advertisingPlayForm">
            <span slot="label" style="color:  #FF0000 ;">广告页播放形式</span>
            <el-select v-model="startFromDate.advertisingPlayForm" clearable placeholder="请选择">
              <el-option
                v-for="item in advertisingOption"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="color:  #FF0000 ;" prop="effectiveTime">
            <span slot="label" style="color:  #FF0000 ;">生效时间</span>
            <el-date-picker
              v-model="startFromDate.effectiveTime"
              value-format="yyyy-MM-dd hh:mm:ss"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <span slot="label">是否每次打开展示</span>
            <el-radio-group v-model="startFromDate.isOpen">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="startFromDate.remark" type="textarea" resize="none" style="width:320px" rows="5" placeholder="请输入内容">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="startSubmitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 广告页查看 -->
    <el-dialog v-dialogDrag :visible.sync="addLookDialog" width="640px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">广告页</span>
      <div v-for="(item, index) in lookAdvertising" :key="index" class="block">
        <el-image style="width: 100px; height: 100px" :src="item" :preview-src-list="lookAdvertising"></el-image>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, saveOne, updateOne, updateMany, getBgColor, upDataBgColor, getBusinessList, saveOrUpdate, appStartPage } from "@/api/basedata/banner.js";
import { getcompany } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
import { getToken, getUserId } from '@/utils/auth';
import { UPLOAD_TIP } from "@/utils/utils";
export default {
  mixins: [mixin],
  data() {
    return {
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      UserInfo: '',
      queryPage: queryPage,
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      contractTypelist: [
        {
          value: "APP banner",
          id: 1,
        },
        {
          value: "小程序 banner",
          id: 2,
        },
        {
          value: "App 启动页",
          id: 3,
        }
      ],
      imageUrl: '',
      fileList: [],
      picturePath: '',
      imageUri: '',
      currenindex: 1,
      fromDate: {
        companyId: '',
        company: '',
        picturePath: '',
        pictureUrl: '',
        enable: 1,
        remark: '',
      },
      startFromDate: {
        id: '',
        applicationId: '',
        applicationName: '',
        businessSystemId: '',
        businessSystemName: '',
        startPage: '',
        startPageTime: 5,
        advertisingPage: '',
        advertisingPlayForm: '',
        effectiveTime: '',
        isOpen: 0,
        remark: '',
      },
      advertisingOption: [
        {
          value: '手动滑动',
          id: '1'
        },
        {
          value: '随机多张',
          id: '2'
        },
        {
          value: '滑动',
          id: '3'
        }
      ],
      startTableData: '',
      advertisingPage: '',
      applicationlist: [{
        id: '11111',
        name: 'icps应用端'
      }],
      lookAdvertising: [],
      addLookDialog: false,
      companylist: [],
      businessList: [],
      applicationList: [],
      selectKeys: [],
      bgColor: '',
      colorId: '',
      ButtonList: [],
      tableParam: {
        companyId: '',
        companyName: '',
        enable: '',
        type: '',
        page: 1,
        pageSize: 10,
      },
      upload_tip:UPLOAD_TIP,
    };
  },
  async created() {
    this.ButtonList = this.$ButtonList()
    this.UserInfo = await getUserInfo();
    getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then((res) => {
      this.companylist = res.data;
    });
    getBusinessList({code: "",name: "",page: 1,pageSize: 9999}).then(res2 => {
      this.businessList = res2.data.data;
    })
    appStartPage({page: 1,pageSize: 9999}).then(res3 => {
      this.startTableData = res3.data.data;
    })
    if (this.UserInfo.adminStatus !== 1) {
      this.tableParam.companyId = this.UserInfo.companyId;
      this.tableParam.companyName = this.UserInfo.companyName;
      this.tableParam.enable = 1;
      this.fromDate.companyId = this.UserInfo.companyId;
      this.fromDate.company = this.UserInfo.companyName;
    }
    this.tableParam.type = this.currenindex;
    this.gettableData();
    this.imageUri = process.env.VUE_APP_API_FILe;
    this.initColor();
  },
  watch: {
    currenindex: {
      //data所有属性都进行监听器，可使用字符串的形式监听对象属性（'item.item1'）
      handler() {
        this.tableParam.type = this.currenindex;
        this.tableParam.page = 1;
        this.init();
        this.initColor();
      },
      deep: false,
      immediate: false,
    },
  },
  methods: {
    initColor() {
      if(this.currenindex !== 3) {
        getBgColor({ type: this.currenindex }).then(res => {
          if (res.code === 1001) {
            this.bgColor = res.data.colorEncoding;
            this.colorId = res.data.id;
          }
        })
      }
    },
    changeColor(value) {
      const params = {
        colorEncoding: value,
        id: this.colorId,
      }
      upDataBgColor(params).then(res => {
        if (res.code === 1001) {
          this.$message.success('修改成功');
        }
      })
    },
    UpdateData(type) {
      const id = this.selectKeys.map((item) => item.id)
      const params = {
        enable: type,
        id: id.join(','),
      }
      if(this.currenindex !== 3) {
        updateMany(params).then(res => {
          if (res.code === 1001) {
            this.$message.success('操作成功')
            this.gettableData();
          }
        })
      }else{
        saveOrUpdate(params).then(res => {
          if (res.code === 1001) {
            this.resefrom();
            this.gettableData();
            this.$message.success('操作成功');
          }
        })
      }
    },
    handleLook(data) {
      this.lookAdvertising = [];
      this.addLookDialog = true;
      const arr = data.split(',');
      arr.forEach(item => {
        this.lookAdvertising.push(this.imageUri + item);
      });
    },
    handleEdit(data) {
      this.addDialog = true;
      this.addDialogTitle = '修改';
      if(this.currenindex != 3) {
        this.picturePath = data.picturePath;
        this.imageUrl = process.env.VUE_APP_API_FILe + data.picturePath;
        this.fromDate = {
          companyId: data.companyId,
          company: data.companyName,
          picturePath: data.picturePath,
          pictureUrl: data.pictureUrl,
          id: data.id,
          enable: data.enable,
          remark: data.remark,
        }
      }else{
        this.fileList = [];
        const arr = data.advertisingPage.split(',');
        arr.forEach((item) => {
          this.fileList.push({url: this.imageUri + item, name: item});
        })
        this.picturePath = data.startPage;
        this.advertisingPage = data.advertisingPage;
        this.imageUrl = process.env.VUE_APP_API_FILe + data.startPage;
        this.startFromDate = {
          id: data.id,
          applicationId: data.applicationId,
          applicationName: data.applicationName,
          businessSystemId: data.businessSystemId,
          businessSystemName: data.businessSystemName,
          startPage: data.startPage,
          startPageTime: data.startPageTime,
          advertisingPage: data.advertisingPage,
          advertisingPlayForm: data.advertisingPlayForm,
          effectiveTime: data.effectiveTime,
          isOpen: data.isOpen,
          remark: data.remark,
        }
      }
    },
    addData() {
      this.addDialog = true;
      this.addDialogTitle = '添加';
      this.picturePath = '';
      this.imageUrl = '';
      this.fileList = [];
      this.advertisingPage = '';
      this.fromDate = {
        companyId: this.UserInfo.companyId,
        company: this.UserInfo.companyName,
        picturePath: '',
        pictureUrl: '',
        enable: 1,
        remark: '',
      }
      this.startFromDate = {
        id: '',
        applicationId: '',
        applicationName: '',
        businessSystemId: '',
        businessSystemName: '',
        startPage: '',
        startPageTime: 5,
        advertisingPage: '',
        advertisingPlayForm: '',
        effectiveTime: '',
        isOpen: 0,
        remark: '',
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code === 1001) {
        this.picturePath = res.data.fileUrl;
      }
    },
    handleManySuccess(res, file) {
      this.fileList.push({
        name: file.name,
        url: URL.createObjectURL(file.raw)
      });
      if (res.code === 1001) {
        this.advertisingPage = this.advertisingPage?this.advertisingPage + "," + res.data.fileUrl:res.data.fileUrl;
      }
    },
    handleRemove(file) {
      const arr = this.advertisingPage.split(',');
      this.advertisingPage = '';
      arr.forEach(item => {
        if(item != file.url.split('/file/')[1]) {
          this.advertisingPage = this.advertisingPage ? this.advertisingPage + "," + item : item;
        }
        return this.advertisingPage
      });
    },
    handleSelectionChange(selectKeys) {
      this.selectKeys = selectKeys;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传的图片格式不正确');
      }
      if (!isLt2M) {
        this.$message.error('上传的图片大小不能超过2M');
      }
      return isJPG && isLt2M;
    },
    init() {
      /*重置数据*/
      this.tableParam.page = 1;
      this.tableParam.enable = 1;
      this.gettableData();
    },
    choose(num) {
      this.currenindex = num;
      if(num == 3) {
        appStartPage({page: 1,pageSize: 9999}).then(res3 => {
          this.startTableData = res3.data.data;
        })
      }
    },
    pagessubmitFromDate() {
      if (!this.picturePath) {
        this.$message.warning('请上传图片')
        return
      }
      const slef = this;
      this.$refs.dialogForm.validate((valid) => {
        const params = {
          ...slef.fromDate,
          type: slef.currenindex,
          picturePath: this.picturePath,
        }
        if (valid) {
          if (params.id) {
            updateOne(params).then((res) => {
              if (res.code === 1001) {
                slef.resefrom();
                slef.gettableData();
                slef.$message.success('修改成功');
              }
            });
            return
          }
          saveOne(params).then((res) => {
            if (res.code === 1001) {
              slef.resefrom();
              slef.gettableData();
              slef.$message.success('新增成功');
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    startSubmitFromDate() {
      if (!this.picturePath || !this.advertisingPage) {
        this.$message.warning('请上传图片')
        return
      }

      if(!this.startFromDate.effectiveTime || !this.startFromDate.advertisingPlayForm) {
        return
      }
      
      this.fileList = [];
      const arr2 = this.advertisingPage.split(',');
      arr2.forEach((item) => {
        this.fileList.push({url: this.imageUri + item, name: item});
      })
      const slef = this;
      this.businessList.forEach(item => {
        if(item.id == this.startFromDate.businessSystemId) {
          slef.startFromDate.businessSystemName = item.name;
          slef.startFromDate.applicationName = 'icps应用端';
          console.log(this.$refs);
          this.$refs.startDialogForm.validate((valid) => {
            const params = {
              ...slef.startFromDate,
              type: slef.currenindex,
              startPage: this.picturePath,
              advertisingPage: this.advertisingPage,
            }
            if(valid) {
              saveOrUpdate(params).then(res => {
                if (res.code === 1001) {
                  slef.resefrom();
                  slef.gettableData();
                  if(params.id) {
                    slef.$message.success('修改成功');
                  }else{
                    slef.$message.success('新增成功');
                  }
                  appStartPage({page: 1,pageSize: 9999}).then(res3 => {
                    this.startTableData = res3.data.data;
                  })
                }
              })
            }
          });
        }
      })
    },
    resefrom() {
      this.addDialog = false;
      this.addLookDialog = false;
      this.$refs.dialogForm.resetFields();
    },
    resetFromDate() {
      this.addDialog = false;
      this.addLookDialog = false;
    }
  },
};
</script>
<style lang="scss">
.mobilebanner {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
<style lang="scss" scoped>
.dialoginfo {
  padding: 0 20px 0 20px;
  .el-input,
  .el-select {
    width: 320px;
  }
}
.dialoginfo-title {
  display: flex;
  align-items: center;
  height: 50px;
  > div {
    width: 4px;
    height: 20px;
    background: $bg_color;
  }
  > span {
    padding-left: 10px;
    font-size: 20px;
    color: $bg_color;
    font-weight: bold;
  }
}
.tabtop {
  width: 570px;
}
.bottom_info{
  color: $bg_color;
}
</style>
